<template>
    <x-icon :color="icon.color">{{ icon.icon }}</x-icon>
</template>

<script>
export default {
    props: ["filename"],
    methods: {
        fileExtension(filename) {
            filename = filename || "";
            return filename.split(".").pop().toLowerCase();
        },
    },
    computed: {
        icon() {
            let icon = {
                icon: "",
                color: "",
            };

            switch (this.fileExtension(this.filename)) {
                case "zip":
                case "rar":
                case "7z":
                    icon.icon = "folder_zip";
                    icon.color = "gold";
                    break;
                case "jpeg":
                case "jpg":
                case "gif":
                case "png":
                case "bmp":
                case "tiff":
                case "tif":
                    icon.icon = "photo_library";
                    icon.color = "mustard";
                    break;
                case "pdf":
                    icon.icon = "picture_as_pdf";
                    icon.color = "poppy";
                    break;
                case "csv":
                case "xls":
                case "xlsx":
                    icon.icon = "pin";
                    icon.color = "teal";
                    break;
                case "doc":
                case "docx":
                case "docm":
                case "dot":
                case "dotx":
                case "dotm":
                case "rtf":
                case "wps":
                case "txt":
                case "odt":
                    icon.icon = "font_download";
                    icon.color = "teal";
                    break;
                default:
                    icon.icon = "file_present";
                    icon.color = "teal";
                    break;
            }

            return icon;
        },
    },
};
</script>
